import WorkOrderExecutionNg from '@/models/WorkOrderExecutionNg/WorkOrderExecutionNg';

export default class WorkOrderExecutionNgFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.ngCategoryId  = '';
		this.ngCategoryCode = '';
		this.ngQty = '';
		this.workOrderExecutionDetailId  = '';
		this.workOrderExecutionDetailWorkOrderProcessDetail = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			ngCategoryId : '0',
			ngCategoryCode : '0',
			ngQty : '0',
			workOrderExecutionDetailId : '0',
			workOrderExecutionDetailWorkOrderProcessDetail : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}